import Button from '@mui/material/Button';
import { useTheme } from '@mui/material/styles';

import Icon from 'src/common/components/icons/Icon';
import { LanguageKeys } from 'src/common/constants/languages';
import { buttonBlockColorSx } from 'src/helpers/buttonBlockStyleUtils';
import { normalizeLocalizedString } from 'src/helpers/localizedStringUtils';
import { IButtonLinkBlock } from 'src/interfaces/PageBlock';

interface Props {
  block: IButtonLinkBlock;
  lang: LanguageKeys;
}

export default function ButtonLinkBlockContent({ block, lang }: Props) {
  const theme = useTheme();
  const label = block.label[lang]?.trim() || block.label.en?.trim() || '';
  const hrefs = normalizeLocalizedString(block.href);
  const href = hrefs[lang]?.trim() || hrefs.en?.trim() || '';
  const hasIcon = Boolean(block.icon?.trim());
  const customColorSx = buttonBlockColorSx(block, theme);
  const useThemeColor = !block.buttonColor?.trim();

  if (!label && !hasIcon) return null;

  return (
    <Button
      href={href || undefined}
      size={block.size ?? 'large'}
      variant={block.variant ?? 'contained'}
      color={useThemeColor ? 'primary' : undefined}
      aria-label={!label && hasIcon ? block.icon : undefined}
      startIcon={hasIcon ? <Icon icon={block.icon!} fontSize="inherit" /> : undefined}
      sx={{ width: { xs: '100%', sm: 'auto' }, ...customColorSx }}
    >
      {label}
    </Button>
  );
}
